
import ShopAboveTheFold from '~/components/v3/ShopAboveTheFold.vue';
import ConsoleTracker from '~/components/v3/ConsoleTracker.vue';
import TestimonialVideos from '~/components/v2/home/TestimonialVideos.vue';
import ReviewsGrid from '~/components/storyblok/ReviewsGrid/ReviewsGrid.vue';
import { CMSService } from '~/services/storyBlok/cmsService';
import FaqsCollapsibleContainer from '~/components/storyblok/FaqsCollapsibleContainer/FaqsCollapsibleContainer.vue';
import OurTrainers from '~/components/v3/OurTrainers.vue';
import SplitView from '~/components/SplitView.vue';
import FCImage from '~/components/FCImage.vue';
import { metaData } from '~/configuration/metaData';
import DropDownVideos from '~/components/v2/shop/DropDownVideos.vue';

const bannerData = {
  _uid: '8e8a4df5-9f8f-4c68-b437-7450c3f27a85',
  codeId: 'WhyChooseFC_ShopBanner',
  height: 'auto',
  scroll: '',
  component: 'PageSection',
  container: [
    {
      _uid: 'f48e0971-7569-4f23-8caa-615d75e4b7a4',
      codeId: '',
      component: 'Banner',
      backgroundColor: '',
      contentPosition: 'center',
      contentContainer: [
        {
          _uid: '93f2d5f0-bf4b-4626-9725-e2e92f408b52',
          codeId: '',
          component: 'MediaBackground',
          brightness: '1',
          isFullWidth: false,
          mediaPosition: '',
          mediaContainer: [
            {
              _uid: 'c0932db2-94f2-46da-a553-02845ff6cfa3',
              Image: {
                id: 16413978,
                alt: '',
                name: '',
                focus: '',
                title: '',
                source: '',
                filename: 'https://a.storyblok.com/f/152150/5760x2576/bcf4e21ca0/image-5.jpg',
                copyright: '',
                fieldtype: 'asset',
                meta_data: {},
                is_private: false,
                is_external_url: false,
              },
              codeId: '',
              component: 'PictureResponsive',
              imageType: '',
              _editable: '<!--#storyblok#{"name": "PictureResponsive", "space": "152150", "uid": "c0932db2-94f2-46da-a553-02845ff6cfa3", "id": "196275687"}-->',
            },
          ],
          backgroundColor: '',
          _editable: '<!--#storyblok#{"name": "MediaBackground", "space": "152150", "uid": "93f2d5f0-bf4b-4626-9725-e2e92f408b52", "id": "196275687"}-->',
        },
        {
          _uid: 'a9a42e5b-6e27-435a-95af-a0364bcd3456',
          text: 'Start Building Your FightCamp Package Today',
          codeId: '',
          isBold: false,
          component: 'ShortText',
          textColor: 'eggshell',
          textTheme: 'heading-2',
          paddingTop: 'fc-padding-top-0',
          elementName: 'h2',
          isUpperCase: false,
          paddingLeft: 'fc-padding-left-0',
          paddingRight: 'fc-padding-right-0',
          paddingBottom: 'fc-padding-bottom-8',
          textAlignment: 'fc-text-center',
          _editable: '<!--#storyblok#{"name": "ShortText", "space": "152150", "uid": "a9a42e5b-6e27-435a-95af-a0364bcd3456", "id": "196275687"}-->',
        },
        {
          _uid: '53236532-1ed8-453c-a9e1-545394ef74e5',
          codeId: '',
          ctaLink: {
            id: '12371015-d3c2-4356-94ab-d274095163ca',
            url: '',
            linktype: 'story',
            fieldtype: 'multilink',
            cached_url: 'shop/products/fightcamp',
          },
          ctaText: 'Build Your FightCamp',
          component: 'LinkButton',
          fullWidth: false,
          buttonTheme: 'button-primary',
          buttonTextSize: 'default',
          buttonAlignment: '',
          _editable: '<!--#storyblok#{"name": "LinkButton", "space": "152150", "uid": "53236532-1ed8-453c-a9e1-545394ef74e5", "id": "196275687"}-->',
        },
      ],
      contentContainerWidth: '',
      _editable: '<!--#storyblok#{"name": "Banner", "space": "152150", "uid": "f48e0971-7569-4f23-8caa-615d75e4b7a4", "id": "196275687"}-->',
    },
  ],
  elementId: '',
  minHeight: '',
  inContainer: false,
  backgroundColor: '',
  _editable: '<!--#storyblok#{"name": "PageSection", "space": "152150", "uid": "8e8a4df5-9f8f-4c68-b437-7450c3f27a85", "id": "196275687"}-->',
};

const mediaData = {
  _uid: 'e473f740-26f4-454d-afe1-108bb14879cd',
  codeId: '',
  component: 'Video',
  isOverlay: false,
  playsAudio: false,
  hasControls: false,
  hasPlayIcon: false,
  hasPauseIcon: false, // added this prop need to clean up Video component once design is confirmed
  mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/partner-workout-optimized-oct-001.mp4',
  webmVideoUrl: '',
  firstFrameImage: {
    id: 16590149,
    alt: '',
    name: '',
    focus: '',
    title: '',
    source: '',
    filename: 'https://a.storyblok.com/f/152150/1080x1080/406c31d0e2/partner-workout-firstframe-001.jpg',
    copyright: '',
    fieldtype: 'asset',
    meta_data: {},
    is_private: false,
    is_external_url: false,
  },
  mp4MobileVideoUrl: '',
  webmMobileVideoUrl: '',
  mobileVideoPlayback: '',
  tabletUpVideoPlayback: '',
};

export default {
  name: 'Shop',
  components: {
    ShopAboveTheFold,
    ConsoleTracker,
    TestimonialVideos,
    ReviewsGrid,
    FaqsCollapsibleContainer,
    OurTrainers,
    SplitView,
    FCImage,
    DropDownVideos,
  },
  data() {
    return {
      reviews: [],
      faqs: [],
      banner: bannerData,
      media: mediaData,
    };
  },
  head: {
    ...metaData.shop,
  },
  async asyncData({ $storyapi }) {
    try {
      const storyBlok = new CMSService({ cmsService: $storyapi });
      const reviews = await storyBlok.getAll('user-reviews', { sort_by: 'content.reviewDate:desc' });

      const faqs = await storyBlok.get('global/globalpackagefaqs');
      const faqList = faqs?.data?.story?.content?.global?.[0]?.container || [];

      return { reviews, faqs: faqList };
    } catch (e) {
      console.log(e);
    }
    return [];
  },
};
